import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import Methods from "./components/Methods";
import Gallery from "./components/Gallery";
import ClassSection from "./components/ClassSection";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-paper-50">
      <Navbar />
      <main>
        <Hero />
        <HotTopics />
        <Methods />
        <Gallery />
        <ClassSection />
        <Faq />
        <About />
      </main>
      <Newsletter />
      <Footer />
    </div>
  );
}